<template>

    <div>
      <div class="loader" v-if="this.isLoading"></div>
      <div class="loadertext" v-if="this.isLoading"> {{ $t('loadingTxt') }}...</div>
      <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
  
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
  
        <div class="page-wrapper">
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
  
              <div class="col-lg-12 col-xl-12 stretch-card">
                <div class="card">
                  <div class="card-header">
                    <h4 style="margin-right: 5px" class="float-start">Bank Transaction</h4>
 
  
  
                    <button v-if="permision_role_block.method_upload" class="btn btn-danger float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="uploadBlockLoadId()">
                      <i class="link-icon mdi mdi-upload"></i>
                      Upload Block Account
                    </button>

                    <button v-if="permision_role_block.method_upload" class="btn btn-primary float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="createData()">
                      <i class="link-icon mdi mdi-plus"></i>
                      Create Block Account
                    </button>
  
  
                    <button v-if="permision_role_block.method_create" class="btn btn-warning float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="changeStatusMass()">
                      <i class="link-icon mdi mdi-upload"></i>
                      Change Status Mass
                    </button>

                    <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="downloadData()">
                      <i class="link-icon mdi mdi-download"></i>
                      {{ $t("downloadData") }} .xlsx
                    </button>

                    <button v-if="permision_role.method_read" class="btn btn-light float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="resetButton()">
                      <i class="link-icon mdi mdi-sync"></i>
                      {{ $t("reset_filter_txt") }}
                    </button>

                    <button v-if="permision_role.method_read" class="btn btn-info float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="searchButton()">
                      <i class="link-icon mdi mdi-account-search"></i>
                      {{ $t("search_txt") }}
                    </button>
                    
  
                  </div>
  
                  <div class="card-body">
                    <vue-good-table title="blujay-bca-transactions" ref="blujay-bca-transactions"
                        mode="remote" @on-page-change="onPageChange"
                        @on-sort-change="onSortChange" @on-column-filter="onColumnFilter" 
                        :key="tableKey"
                        @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :line-numbers="true"
                        :isLoading.sync="isLoading" 
                        :pagination-options="{
                            enabled: true,
                            perPageDropdown: [10, 50, 100, 1000, 10000],
                            dropdownAllowAll: false,
                        }"
                        :rows="rows" :columns="columns"
                      >
  
                  
                    <template slot="column-filter" slot-scope="{ column }">
                      
                      <span v-if="column.filterOptions.customFilter">


                        <span v-if="column.field =='date'">

                          <date-range-picker style="width:100%" @update="fromDatesChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="fromDates" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                            <div slot="header" slot-scope="header" class="slot">
                              <a @click="clearfromDatesChange()" class="float-end" style="margin-right: 5px;color:red;">Clear Calendar</a> <span v-if="header.in_selection"> - in selection</span>
                              <br>
                            </div>
                          </date-range-picker>

                        </span>
                      
                      </span>
                      

                    </template>
 
  
                      <template slot="table-row" slot-scope="props">
                      
                        <span v-if="props.column.field == 'actions'">

                          <a href="#" v-if="permision_role.method_delete" title="Delete"
                            @click.prevent="deleteData(props.index, props.row)">
                            <i class="mdi mdi mdi-delete-forever" style="font-size:16px;color:red;padding-right: 10%;"></i>
  
                          </a>

                          <a href="#" v-if="permision_role.method_read" title="Detail" @click.prevent="
                            detailData(props.index, props.row)
                            ">
                            <i class="mdi mdi-eye" style="font-size:16px;color:blue;padding-right: 10%;"></i>
  
                          </a>
                          <a href="#" v-if="permision_role.method_update && props.row.status_code=='WAITING_APPROVAL'" title="Approve"
                            @click.prevent="approveData(props.index, props.row)">
                            <i class="mdi mdi-thumb-up" style="font-size:16px;padding-right: 10%;"></i>
                          </a>
                          <a href="#" v-if="permision_role.method_update && props.row.status_code=='WAITING_APPROVAL'" title="Reject"
                            @click.prevent="rejectData(props.index, props.row)">
                            <i class="mdi mdi-thumb-down" style="font-size:16px;color:red;"></i>
  
                          </a>
    
                        </span>
                        <span v-else-if="props.column.field == 'amount'">
                          {{toCurrency(props.row.amount)}}
                        </span>
                        <span v-else>
                          {{ props.formattedRow[props.column.field] }}
                        </span>
                      </template>

                    </vue-good-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
  
   
  
  
  
  
  
          <!--begin::modal-->

            <modal name="createBlockLoadId" :draggable="false" :scrollable="true" :height="'auto'">
                <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true"
                role="dialog">
                <div class="modal-dialog  modal-xl">
                    <div class="modal-content">
    
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Create Block Account</h5>
                        <button type="button" class="btn btn-default"  @click.prevent="removeModals()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
    
                        <form class="forms-sample" @submit.prevent="submitData()" method="POST">

                            <div class="modal-body">

                                    <div class="mb-3">

                                        <label for="recipient-name" class="form-label">Load ID</label>
                                                        
                                        <input
                                            type="text"
                                            class="form-control"
                                            :id="this.$dynamicId()"
                                            v-model="forms.load_id"
                                            required
                                        />
                                        <div v-if="errors.load_id">
                                        <div v-for="error in errors.load_id" :key="error" class="alert alert-primary" role="alert">
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                        </div>
                                        </div>

                                    </div>
                                    <div class="mb-3">

                                        <label for="message-text" class="form-label">Remarks</label>
                                               
                                        <input
                                            type="text"
                                            class="form-control"
                                            :id="this.$dynamicId()"
                                            v-model="forms.remarks"
                                            required
                                        />
                                         

                                        <div v-if="errors.remarks">
                                        <div v-for="error in errors.remarks" :key="error" class="alert alert-primary" role="alert">
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                        </div>
                                        </div>

                                    </div>

                            </div>
            
            
                            <div class="modal-footer justify-content-between">

                                <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
                                <button type="submit" class="btn btn-primary">{{this.$t("submitFormTxt")}}</button>
            

                            </div>
    
                        </form>
    
                    </div>
                </div>
                </div>
            </modal>


            <modal name="changeStatusMass" :draggable="false" :scrollable="true" :height="'auto'">
                <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true"
                role="dialog">
                <div class="modal-dialog  modal-xl">
                    <div class="modal-content">
    
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Change Status</h5>
                        <button type="button" class="btn btn-default"  @click.prevent="removeModals()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
     
                        <form class="forms-sample" @submit.prevent="submitDataChangeStatus()" method="POST" enctype="multipart/form-data">

                            <div class="modal-body">

                                    <div class="mb-3">

                                        <label for="recipient-name" class="form-label">Load ID</label>
                                                  
                                        <v-select
                                        :options="['SUCCESS','FAILED']"
                                        v-model="formsChangeStatus"
                                        return-object 
                                        required
                                        ></v-select>      
                                     
                                        <div v-if="errors.status">
                                        <div v-for="error in errors.status" :key="error" class="alert alert-primary" role="alert">
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                        </div>
                                        </div>

                                    </div>
                                    <div class="mb-3">

                                        <label for="message-text" class="form-label">File</label>
                                               
                                        <input type="file" ref="file" class="form-control" @change="handleFileUpload($event)" />
                                         

                                        <div v-if="errors.file">
                                            <div v-for="error in errors.file" :key="error" class="alert alert-primary" role="alert">
                                                <i data-feather="alert-circle"></i>
                                                {{ error }}
                                            </div>
                                        </div>

                                    </div>
                                    <div class="mb-3">

                                        <label for="message-text" style="text-align: right !important;color:blue;"><a @click="downloadTemplateChangeStatus()">Download Template</a></label>
                                          
                                        <div v-if="resultChangeStatus.length > 0">
                                            <br>
                                            <br>
                                            <br>
                                            <table class="table">

                                                <thead>
                                                    <tr>
                                                    <th scope="col">#</th>
                                                    <th scope="col">Load ID</th>
                                                    <th scope="col">Status</th>
                                                    <th scope="col">Message</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(resultNya,index) in resultChangeStatus" :key="index">
                                                    <th scope="row">{{index+1}}</th>
                                                    <td>{{resultNya.load_id}}</td>
                                                    <td>{{resultNya.status}}</td>
                                                    <td>{{resultNya.message}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
 
                                        </div>


                                    </div>

                            </div>
            
            
                            <div class="modal-footer justify-content-between">

                                <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
                                <button type="submit" class="btn btn-primary">{{this.$t("submitFormTxt")}}</button>
            

                            </div>
    
                        </form>
     
    
                    </div>
                </div>
                </div>
            </modal>


            <modal name="uploadBlockLoadId" :draggable="false" :scrollable="true" :height="'auto'">
                <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true"
                role="dialog">
                <div class="modal-dialog  modal-xl">
                    <div class="modal-content">
    
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Upload Block Account</h5>
                        <button type="button" class="btn btn-default"  @click.prevent="removeModals()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
     
                        <form class="forms-sample" @submit.prevent="submitDatauploadBlockLoadId()" method="POST" enctype="multipart/form-data">

                            <div class="modal-body">
 
                                    <div class="mb-3">

                                        <label for="message-text" class="form-label">File</label>
                                               
                                        <input type="file" ref="fileuploadBlockLoadId" class="form-control" @change="handleFileUploaduploadBlockLoadId($event)" />
                                         

                                        <div v-if="errors.file">
                                            <div v-for="error in errors.file" :key="error" class="alert alert-primary" role="alert">
                                                <i data-feather="alert-circle"></i>
                                                {{ error }}
                                            </div>
                                        </div>

                                    </div>
                                    <div class="mb-3">

                                        <label for="message-text" style="text-align: right !important;color:blue;"><a @click="downloadTemplateChangeStatusuploadBlockLoadId()">Download Template</a></label>
                                          
                                        <div v-if="resultChangeStatus.length > 0">
                                            <br>
                                            <br>
                                            <br>
                                            <table class="table">

                                                <thead>
                                                    <tr>
                                                    <th scope="col">#</th>
                                                    <th scope="col">Load ID</th>
                                                    <th scope="col">Status</th>
                                                    <th scope="col">Message</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(resultNya,index) in resultChangeStatus" :key="index">
                                                    <th scope="row">{{index+1}}</th>
                                                    <td>{{resultNya.load_id}}</td>
                                                    <td>{{resultNya.status}}</td>
                                                    <td>{{resultNya.message}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
 
                                        </div>


                                    </div>

                            </div>
            
            
                            <div class="modal-footer justify-content-between">

                                <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
                                <button type="submit" class="btn btn-primary">{{this.$t("submitFormTxt")}}</button>
            

                            </div>
    
                        </form>
     
    
                    </div>
                </div>
                </div>
            </modal>
 

          <!--end::modal-->
  
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>

</template>
    
<script>

    import navbarComponent from "@/components/_partials/_navbar";
    import footerComponent from "@/components/_partials/_footer";
    import DateRangePicker from 'vue2-daterange-picker';
  
  export default {
    name: "BlujayBcaTransactionIndex",
    components: {
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        DateRangePicker,
    },
    data() {
      return {
        digit: {
            decimal: ',',
            thousands: '.',
            prefix: ' ',
            suffix: '',
            precision: 5,
            masked: false
          },
        opens:"center",
        locale:{
            format:"yyyy-mm-dd",
        
        },
        fromDates: {
            startDate: null,
            endDate: null
        },
        firstDates:{
            startDate: null,
            endDate: null
        },
        highlighted:{

            dates: [ // Highlight an array of dates
                new Date(),
            ],

        },
        tableKey:1,
        file: '',
        fileuploadBlockLoadId: '',
        formsChangeStatus:'',
        fetchUsers:[],
        fetchLocations:[],
        filterOrderType:[],
        forms: {load_id:"",remarks:""},
        maxToasts: 100,
        position: "up right",
        closeBtn: true,
        isLoading: false,
        errors: [],
        idAsnHeaders:[],
        permision_role: [],
        permision_role_block:[],
        langs: ["id", "en"], 
        totalRecords: 0,
        activeFlag : false,
        shelfLifeFlag : false,
        kitFlag : false,
        freePickGift : false,
        serverParams: {
          columnFilters: {},
          sort: {
            field: "",
            type: "",
          },
          page: 1,
          per_page: 10,
        },       
        columns: [

            {
                label: 'ID',
                width: '50px',
                field: "bank_transaction_id",
                thClass: 'text-center',
                filterOptions: {
                    customFilter: false,
                    enabled: true, // enable filter for this column
                    placeholder: '', // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    trigger: "enter", //only trigger on enter not on keyup
                },
            },

            {
                label: 'Type',
                width: '50px',
                field: "type",
                thClass: 'text-center',
                filterOptions: {
                    customFilter: false,
                    enabled: true, // enable filter for this column
                    placeholder: '', // placeholder for filter input
                    filterValue: "", // initial populated value for this filter
                    trigger: "enter", //only trigger on enter not on keyup
                },
            },

            {
                label: 'Date',
                field: "date",
                thClass: 'text-center',
                filterOptions: {
                customFilter: true,
                enabled: true, // enable filter for this column
                placeholder: '', // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                trigger: "enter", //only trigger on enter not on keyup
                },
            },  

            {
                label: 'Load ID',
                field: "load_id",
                thClass: 'text-center',
                filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: '', // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                trigger: "enter", //only trigger on enter not on keyup
                },
            }, 

            {
                label: 'Location',
                field: "location",
                thClass: 'text-center',
                filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: '', // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                trigger: "enter", //only trigger on enter not on keyup
                },
            }, 

            {
                label: 'Driver Name',
                field: "driver_name",
                thClass: 'text-center',
                filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: '', // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                trigger: "enter", //only trigger on enter not on keyup
                },
            }, 

            {
                label: 'Amount',
                field: "amount",
                thClass: 'text-center',
                filterOptions: {
                customFilter: false,
                enabled: false, // enable filter for this column
                placeholder: '', // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                trigger: "enter", //only trigger on enter not on keyup
                },
            }, 

            {
                label: 'Account Number',
                field: "account_number",
                thClass: 'text-center',
                filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: '', // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                trigger: "enter", //only trigger on enter not on keyup
                },
            }, 

            {
                label: 'Approval By',
                field: "approval_by",
                thClass: 'text-center',
                filterOptions: {
                customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: '', // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                trigger: "enter", //only trigger on enter not on keyup
                },
            }, 

            {
                label: 'Status',
                field: "status_code",
                thClass: 'text-center',
                filterOptions: {
                    customFilter: false,
                    enabled: true, // enable filter for this column
                    placeholder: '', // placeholder for filter input
                    filterValue: "WAITING_APPROVAL", // initial populated value for this filter
                    filterDropdownItems: ['NEW','SEND','SUCCESS','WAITING_APPROVAL','APPROVED','FAILED'], // dropdown (with selected values) instead of text input
                    trigger: "enter", //only trigger on enter not on keyup
                },
            }, 
            
            {
                label: this.$t("action_txt"),
                width: '10%',
                field: "actions",
                thClass: 'text-center',
                sortable: false,
                filterOptions: {
                customFilter: false,
                }
            },
        ],
        rows: [],
        rowsSelection: [],
        errorsDataSoUpload: false,
        transactionFromDate:"",
        transactionToDate:"",
        resultChangeStatus:[],
      };
    },
    watch: {},
    methods: {

        resetButton(){

            this.transactionFromDate    = "";
            this.transactionToDate      = "";
            this.tableKey += 1;
            this.loadItems();
            this.$refs['blujay-bca-transactions'].reset();

        },

        searchButton(){

            const elementtype                   = document.querySelector('[name="vgt-type"]');
            const elementbank_transaction_id    = document.querySelector('[name="vgt-bank_transaction_id"]');
            const elementlocation               = document.querySelector('[name="vgt-location"]');
            const elementstatus_code            = document.querySelector('[name="vgt-status_code"]');
            const elementload_id                = document.querySelector('[name="vgt-load_id"]');
            const elementdriver_name            = document.querySelector('[name="vgt-driver_name"]');
            const elementaccount_number         = document.querySelector('[name="vgt-account_number"]');
            const elementapproval_by            = document.querySelector('[name="vgt-approval_by"]');
            var params  = {
                    "columnFilters": {
                        "type"                  : elementtype.value,
                        "bank_transaction_id"   : elementbank_transaction_id.value,
                        "location"              : elementlocation.value,
                        "status_code"           : elementstatus_code.value,
                        "load_id"               : elementload_id.value,
                        "driver_name"           : elementdriver_name.value,
                        "account_number"        : elementaccount_number.value,
                        "approval_by"           : elementapproval_by.value
                    
                    },
                    "page": 1
                };

            this.updateParams(params)
        },

        submitDatauploadBlockLoadId() {
            this.$swal({
            title: this.$t("areYouSure"),
            text: this.$t("yourData"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
            }).then((result) => {
            if (result.value) {
                this.fade(true);
    
                let formData = new FormData();
                formData.append("file", this.fileuploadBlockLoadId);
            
                const baseURI = this.$settings.endPointBlujayBca + "v2/bank-transaction/upload-block-account";
                this.$http.post(baseURI,formData).then((response) => {
                    this.loading();
                    if(response.data.status === 200) {
                         
                        this.loading();
                        this.errors = [];
                        this.resultChangeStatus = response.data.datas;
                        
                    }else{
                    
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                }).catch(error => {
                    this.loading();
                    this.tableError=true;
                    if (error.response) {
                    if (error.response.status === 422) {
                        this.errorsData = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                        this.logout();
                    } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                    } else {
                        this.$router.push('/page-not-found');
                    }
                    }

                    
                });
            }
            });
        },

        submitDataChangeStatus() {
            this.$swal({
            title: this.$t("areYouSure"),
            text: this.$t("yourData"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
            }).then((result) => {
            if (result.value) {
                this.fade(true);
    
                let formData = new FormData();
                formData.append("file", this.file);
                formData.append("status", this.formsChangeStatus);
            
                const baseURI = this.$settings.endPointBlujayBca + "v2/bank-transaction/change-status-upload";
                this.$http.post(baseURI,formData).then((response) => {
                    this.loading();
                    if(response.data.status === 200) {
                         
                        this.loading();
                        this.errors = [];
                        this.resultChangeStatus = response.data.datas;
                        
                    }else{
                    
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                }).catch(error => {
                    this.loading();
                    this.tableError=true;
                    if (error.response) {
                    if (error.response.status === 422) {
                        this.errorsData = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                        this.logout();
                    } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                    } else {
                        this.$router.push('/page-not-found');
                    }
                    }

                    
                });
            }
            });
        },

        downloadTemplateChangeStatusuploadBlockLoadId() {
            const baseURI = this.$settings.endPointBlujayBca + "v2/bank-transaction/block-account-template";
            this.isLoading = true;
            
          
            var file_name = "block_account_template.xlsx";
            
            return this.$http
            .get(
                baseURI,    
                {
                    responseType: "blob",
                }
            )
            .then((response) => {
    
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");
    
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.fade(false);
            });

        },

        downloadTemplateChangeStatus() {
            const baseURI = this.$settings.endPointBlujayBca + "v2/bank-transaction/change-status-template";
            this.isLoading = true;
            
          
            var file_name = "change_status_template.xlsx";
            
            return this.$http
            .get(
                baseURI,    
                {
                    responseType: "blob",
                }
            )
            .then((response) => {
    
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");
    
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.fade(false);
            });

        },

        handleFileUpload( event ){
            this.file = event.target.files[0];
        },

        handleFileUploaduploadBlockLoadId( event ){
            this.fileuploadBlockLoadId = event.target.files[0];
        },

        fromDatesChange(){

            if(this.fromDates.startDate && this.fromDates.endDate){
                this.transactionFromDate=this.$moment(String(this.fromDates.startDate)).format('YYYY-MM-DD');
                this.transactionToDate=this.$moment(String(this.fromDates.endDate)).format('YYYY-MM-DD');
                this.loadItems()
            }

        },

        clearfromDatesChange(){
            this.fromDates={
                startDate: null,
                endDate: null
            };
            this.transactionFromDate = ""
            this.transactionToDate = ""
            this.loadItems()
        },

        toCurrency (value) {
            if (typeof value !== "number") {
                return value;
            }
            var formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'IDR'
            });
            return formatter.format(value);
        },

        asyncSearchUser(ev){
            const baseURI = this.$settings.endPoint + "user?username="+ev;

            return this.$http.get(baseURI).then((response) => {
                this.fetchUsers = response.data.datas.data;
            });
        },
  
   
        asyncSearchLocations(ev){
            const baseURI = this.$settings.endPoint + "blujay-bca/location/index?download=pluck&location="+ev;

            return this.$http.get(baseURI).then((response) => {
                this.fetchLocations = response.data.datas;
            });
        },

        submitData() {
 
            this.isLoading = true;

    
            const baseURI = this.$settings.endPointBlujayBca + "v2/bank-transaction/block-account";
 

            this.$http.post(baseURI, this.forms, { timeout: 10000 }).then((response) => {
                this.loading();
                if (response.data.status === 200) {
                //this.resetForm();
                this.isLoading = false;
                this.errors = [];
                this.loadItems();
                this.removeModals();
                this.success('Berhasil');
                } else {
                this.isLoading = false;
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
                }
            }).catch(error => {
                this.loading();
                this.isLoading = false;
                if (error.code == "ECONNABORTED") {
                this.error("Please Check Your Internet Connection");
                }

                if (error.response) {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                } else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                } else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                } else {
                    this.$router.push('/page-not-found');
                }
                }
                //this.resetForm();
            });
 
        },

   
        editSubmitData() {

            this.isLoading = true;

            var formsSubmit = {user_id:this.forms.user_detail.id , locations:this.forms.locations};
            const baseURI = this.$settings.endPoint + "blujay-bca/user-mapping/update/"+this.forms.user_location_id;
            this.$http.patch(baseURI, formsSubmit, { timeout: 10000 }).then((response) => {
                this.loading();
                if (response.data.status === 200) {
                //this.resetForm();
                this.isLoading = false;
                this.errors = [];
                this.loadItems();
                this.removeModals();
                this.success('Berhasil');
                } else {
                this.isLoading = false;
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
                }
            }).catch(error => {
                this.loading();
                this.isLoading = false;
                if (error.code == "ECONNABORTED") {
                this.error("Please Check Your Internet Connection");
                }

                if (error.response) {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                } else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                } else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                } else {
                    this.$router.push('/page-not-found');
                }
                }
                //this.resetForm();
            });

        },

  
 
        removeModals() {
            this.$modal.hide('createBlockLoadId')
            this.$modal.hide('changeStatusMass')
            this.$modal.hide('uploadBlockLoadId')
            this.forms.user_location_id = ""
            this.forms.user_id          = ""
            this.forms.locations        = []
            this.forms.user_detail      = {}
            this.errors                 = []
            this.loadItems();
    
        },
  
        downloadData() {
            const baseURI = this.$settings.endPointBlujayBca + "v2/bank-transaction/index";
            this.isLoading = true;
            
            let dateNya = ""
            if(this.transactionFromDate != '' && this.transactionToDate != '' ){
                dateNya = this.transactionFromDate+"~"+this.transactionToDate
            }

            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name = "download_" + CurrentDate + ".xlsx";
            
            return this.$http
            .get(
                baseURI +
                `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&bank_transaction_id=${this.serverParams.columnFilters.bank_transaction_id}&type=${this.serverParams.columnFilters.type}&driver_name=${this.serverParams.columnFilters.driver_name}&location=${this.serverParams.columnFilters.location}&load_id=${this.serverParams.columnFilters.load_id}&status_code=${this.serverParams.columnFilters.status_code}&approval_by=${this.serverParams.columnFilters.approval_by}&date=${dateNya}&download=download`,
    
                {
                responseType: "blob",
                }
            )
            .then((response) => {
    
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");
    
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.fade(false);
            });

        },
  
        createData() {
            this.forms.load_id      = ""
            this.forms.remarks      = ""
            this.errors                     = []
            this.$modal.show('createBlockLoadId')
        },
  
       
        uploadBlockLoadId() {
            
            this.fileuploadBlockLoadId      = ''
            this.resultChangeStatus         = []
            this.errors                     = []
            this.$modal.show('uploadBlockLoadId')

        },
       
        changeStatusMass() {
            
            this.file                       = ''
            this.formsChangeStatus          = ''
            this.resultChangeStatus         = []
            this.errors                     = []
            this.$modal.show('changeStatusMass')

        },
  
        deleteData(index, row) {
            
            this.$swal({
            title: this.$t("areYouSure"),
            text: this.$t("yourDataDelete"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
            }).then((result) => {
            if (result.value) {
      
                const baseURI =  this.$settings.endPointBlujayBca + "v2/bank-transaction/delete/" + row.bank_transaction_id;
                this.$http
                .delete(baseURI, { timeout: 10000 })
                .then((response) => {
                    this.loading();
                    if (response.data.status === 200) {
                    this.success(response.data.datas.messages);
                    this.loadItems();
                    } else {
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                    }
                }).catch((error) => {
                    this.loading();
    
                    if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
    
                    } else {
    
    
                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));
    
                    } else {
    
                        if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        } else {
                            this.$router.push('/page-not-found');
                        }
                        }
    
                    }
    
                    }
                });
            } else {
                this.isLoading = false;
            }
            });
        },
  
        approveData(index, row) {
            
            this.$swal({
            title: this.$t("areYouSure"),
            text: this.$t("yourDataApprove"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
            }).then((result) => {
            if (result.value) {
                
                var forms = {
                    approval_status:"APPROVED"
                };

                const baseURI =  this.$settings.endPointBlujayBca + "v2/bank-transaction/approval/" + row.bank_transaction_id;
                this.$http
                .post(baseURI, forms , { timeout: 10000 })
                .then((response) => {
                    this.loading();
                    if (response.data.status === 200) {
                    this.success(response.data.datas.messages);
                    this.loadItems();
                    } else {
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                    }
                }).catch((error) => {
                    this.loading();
    
                    if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
    
                    } else {
    
    
                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));
    
                    } else {
    
                        if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        } else {
                            this.$router.push('/page-not-found');
                        }
                        }
    
                    }
    
                    }
                });
            } else {
                this.isLoading = false;
            }
            });
        },
  
        rejectData(index, row) {
           
            let inputValue = ""
            this.$swal.fire({
                title: this.$t("yourRemarks") + ' Reject',
                input: "text",
                inputValue,
                showCancelButton: true,
                inputValidator: (value) => {
                    if (!value) {
                    return "You need to write something!";
                    }else{
                        
                        var forms = {
                            approval_status:"REJECTED",
                            remarks:value
                        };

                        const baseURI =  this.$settings.endPointBlujayBca + "v2/bank-transaction/approval/" + row.bank_transaction_id;
                        this.$http.post(baseURI, forms , { timeout: 10000 })
                            .then((response) => {
                                this.loading();
                                if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.loadItems();
                                } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                                }
                            }).catch((error) => {
                                this.loading();
                
                                if (error.code == "ECONNABORTED") {
                                this.error(this.$t("check_internet_connection_txt"));
                
                                } else {
                
                
                                if (error.code == "ECONNABORTED") {
                                    this.error(this.$t("check_internet_connection_txt"));
                
                                } else {
                
                                    if (error.response) {
                                    if (error.response.status === 422) {
                                        this.errors = error.response.data.errors;
                                        this.resultError(error.response.data.errors);
                                    } else if (error.response.status === 401) {
                                        this.logout();
                                    } else if (error.response.status === 403) {
                                        this.$router.push("/authorized-error");
                                    } else if (error.response.status === 500) {
                                        this.$router.push('/server-error');
                                    } else {
                                        this.$router.push('/page-not-found');
                                    }
                                    }
                
                                }
                
                                }
                            });


                    }
                }
            });
             
        },

 
        detailData(index, row) {
            var params = this.$onRandom(row.bank_transaction_id);
            window.location.href = "/blujay-bca/transactions/detail/" + params;
        },
  
        // load items is what brings back the rows from server
        loadItems() {
            const baseURI = this.$settings.endPointBlujayBca + "v2/bank-transaction/index";
            this.isLoading = true;
            
            let dateNya = ""
            if(this.transactionFromDate != '' && this.transactionToDate != '' ){
                dateNya = this.transactionFromDate+"~"+this.transactionToDate
            }
 
         
            return this.$http
            .get(
                baseURI +
                `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&bank_transaction_id=${this.serverParams.columnFilters.bank_transaction_id}&type=${this.serverParams.columnFilters.type}&driver_name=${this.serverParams.columnFilters.driver_name}&location=${this.serverParams.columnFilters.location}&load_id=${this.serverParams.columnFilters.load_id}&status_code=${this.serverParams.columnFilters.status_code}&approval_by=${this.serverParams.columnFilters.approval_by}&date=${dateNya}`
                )
            .then((response) => {
                this.isLoading = false;
                this.rows = response.data.datas.data;
            

                this.totalRecords = response.data.datas.total;
            }).catch((error) => {
                this.loading();
    
                if (error.code == "ECONNABORTED") {

                    this.error(this.$t("check_internet_connection_txt"));
    
                } else {
    
                    if (error.response) {
                        if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                        this.logout();
                        } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                        } else {
                        this.$router.push('/page-not-found');
                        }
                    }
    
                }
            });
        },

  
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            this.loadItems();
        },
  
        onColumnFilter(params) {
            this.updateParams(params);
        },
    
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
        },
    
        onSortChange(params) {
            this.updateParams({
            sort: {
                type: params[0].type,
                field: params[0].field,
            },
            });
        },
    
        onPerPageChange(params) {
            this.updateParams({ per_page: params.currentPerPage });
        },
    
        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
            var nameOb = Object.keys(data)[x];
            var objectData = data[nameOb];
            for (var y = 0; y < objectData.length; y++) {
                this.error(objectData[y]);
            }
            }
        },
  
        success(kata) {
            const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
            });
            Toast.fire({
            icon: "success",
            title: kata,
            });
        },
    
        error(kata) {
            const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
            });
            Toast.fire({
            icon: "error",
            title: kata,
            });
        },
    
        fade(sType) {
            this.isLoading = sType;
        },
    
        loading() {
            this.fade(true);
            setTimeout(() => {
            this.isLoading = false;
            }, 1000); // hide the message after 3 seconds
        },
    
        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            let rolePermisionBlock = [];
            userDatas.sub.permision_role.forEach(function (permision) {
            // console.log(permision.permission.controller);
            if (permision.permission.controller == 'BankTransactionsController') {
                rolePermision = permision;
            }
            if (permision.permission.controller == 'BankTransactionsBlockAccountController') {
                rolePermisionBlock = permision;
            }
            });
    
            if (!rolePermision.method_read) {
            this.$router.push("/authorized-error");
            }
            this.permision_role = rolePermision;
            this.permision_role_block = rolePermisionBlock;
    
        },
    
    
        logout() {
    
            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
    
            console.log(response);
    
            });
    
            this.$logoutUser();
            window.location.href = '/';
        },
      
    },
    events: {},
    created: function () { },
    
    mounted() {
      this.fetchIt();
      this.loading();
    },
  };
</script>

<style scoped>

  .blur-content {
    filter: blur(5px);
  }

</style>